import type React from 'react';
import type { ReactNode } from 'react';
import { Outlet } from 'react-router';
import styled from 'styled-components';
import { VersionInfo } from '../components/VersionInfo';
import { DualPanelLayout } from '../dualPanel';

const AppContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  overflow: hidden;
  flex-grow: 1;
  font-size: 16px;
  width: 100%;
  height: 100%;
`;

type AppShellProps = {
  /** Mode-specific sidebar (conversation history, dashboard list, …). */
  sidebar: ReactNode;
  /** Main content. Defaults to the routed `<Outlet/>`; pass a node to gate it (e.g. a loader). */
  children?: ReactNode;
};

/**
 * Authenticated frame: a mode's sidebar + its routed content, split with the widget panel,
 * + the version footer. Every mode gets the dual panel, so it lives here rather than in each
 * mode's layout.
 */
export const AppShell: React.FC<AppShellProps> = ({ sidebar, children }) => (
  <AppContainer>
    {sidebar}
    <DualPanelLayout>{children ?? <Outlet />}</DualPanelLayout>
    <VersionInfo />
  </AppContainer>
);
